import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DeleteOutlined, FileImageOutlined } from '@ant-design/icons';
import IconButton from 'components/IconButton';
import styles from '../style.module.less';
const MAX_TITLE_LENGTH = 25;
const FileItem = ({ file, onRemove }) => {
    const fileSize = file.originFileObj
        ? `${(file.originFileObj.size / 1024 / 1024).toFixed(2)} MB`
        : '';
    return (_jsxs("div", { className: styles.fileItem, children: [_jsx(FileImageOutlined, { className: styles.fileIcon }), _jsxs("div", { className: styles.fileItemLabel, children: [_jsx(FileImageOutlined, {}), file.name.length < MAX_TITLE_LENGTH ? file.name : `${file.name.slice(0, MAX_TITLE_LENGTH)}...`, fileSize.length > 0 ? ` (${fileSize})` : null] }), _jsx(IconButton, { onClick: () => onRemove(file), className: styles.removeButton, children: _jsx(DeleteOutlined, {}) })] }));
};
export default FileItem;
